export const SET_SHOW_STEPPER = "SET_SHOW_STEPPER";
export const SET_CONFIGURATOR_VIEW = "SET_CONFIGURATOR_VIEW";
export const SET_SELECTED_ASSETS = "SET_SELECTED_ASSETS";
export const SET_SELECTED_SIGNAL = "SET_SELECTED_SIGNAL";
export const SET_LIMIT_AND_NOTIFICATIONS = "SET_LIMIT_AND_NOTIFICATIONS";
export const SET_FREQUENCY_LIMIT_MODELS = "SET_FREQUENCY_LIMIT_MODELS";
export const SET_UPDATE_RESULTS = "SET_UPDATE_RESULTS";
export const SET_LIMITS_DISABLE = "SET_LIMITS_DISABLE";
export const RESET_UPDATE_RESULTS = "RESET_UPDATE_RESULTS";
export const SET_FEEDBACK_MESSAGE = "SET_FEEDBACK_MESSAGE";
export const SET_LOADER_ON = "SET_LOADER_ON";
export const SET_LOADER_OFF = "SET_LOADER_OFF";
export const SET_TURBINE_PARTIAL_ERROR = "SET_TURBINE_PARTIAL_ERROR";
export const PUSH_FREQUENCY_LIMIT_MODEL = "PUSH_FREQUENCY_LIMIT_MODEL";
